import { HostListener, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AreYouSureGuard  {
  canDeactivate(
    component: any,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    // If the calling component has not implemented dirty, or dirty is false, do nothing
    if (!component?.dirty) {
      return true;
    }

    // Dirty must be true on the calling component
    return confirm('Are you sure you want to leave? You have unsaved changes.');
  }
}
